// extracted by mini-css-extract-plugin
var _1 = "HeroLayout-module__content___k03U3";
var _2 = "HeroLayout-module__hero___ZdWL_";
var _3 = "HeroLayout-module__img___blvaN";
var _4 = "HeroLayout-module__picture___iSNaB";
export { _1 as "content", _2 as "hero", _3 as "img", _4 as "picture" }
